// @owners { team: patients-team }
import { InputText, Row } from '@alto/design-system';
import React, { useCallback, useState } from 'react';
import { CUSTOM_TIP_PLACEHOLDER, MAX_TIP_AMOUNT_LENGTH } from '~shared/features/courier-tips/constants';
import { formatDollars, formatInputAsCurrency } from '~shared/helpers/currency';

type Props = {
  readonly alignCenter?: boolean;
  readonly editTipAmount: (tipAmount: number) => void;
  readonly initialTipAmount: number;
};

export default function CustomTipInput({ alignCenter = false, editTipAmount, initialTipAmount }: Props) {
  let initialDisplayValue = '';
  if (initialTipAmount > 0) {
    initialDisplayValue = formatDollars(initialTipAmount, false);
  }
  const [displayValue, setDisplayValue] = useState(initialDisplayValue);

  const handleChangeTipAmount = useCallback(
    (event: { target: { value: string | null | undefined } }) => {
      const currencyValue = formatInputAsCurrency(event.target.value);
      const currencyValueAsNumber = Number(currencyValue) || 0;
      setDisplayValue(currencyValue);
      editTipAmount(currencyValueAsNumber);
    },
    [editTipAmount, setDisplayValue],
  );

  return (
    <>
      <Row center={alignCenter}>
        <InputText
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          leftIconProps={{ type: 'grey', name: 'pricetag' }}
          maxLength={MAX_TIP_AMOUNT_LENGTH}
          // @ts-expect-error event.target.value works for web
          onChange={handleChangeTipAmount}
          placeholder={CUSTOM_TIP_PLACEHOLDER}
          value={displayValue}
        />
      </Row>
    </>
  );
}
